module.exports = __webpack_public_path__ + "fonts/Roboto-500-vietnamese46.3860f0d.woff2";